import { AuthActionTypes } from '../actions/actionTypes';
import storage from '../../Utility/storage';

const token = storage.get('token', null);
const refresh_token = storage.get('refresh_token', null);
const user = storage.get('user', null);

export const initialState = {
   token: token,
   refresh_token: refresh_token,
   user: user,
   plans: null,
   isLoading: false,
   planid: null,
   planName: null,
   planPrice: null,
   subdata: null,
   discountPrice: null,
   cancelsubdata: null,
   isImageUploading: false,
   photo_path: [],
   resetPasswordSuccessAPI: {},
   forgotPasswordSuccessAPI: {},
   successCall: null,
};

const updateObject = (oldState, updatedProps) => {
   return {
      ...oldState,
      ...updatedProps,
   };
};

export const authReducer = (state = initialState, action) => {
   switch (action.type) {
      case AuthActionTypes.LOGIN_PENIDNG:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.LOGIN_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            user: action.payload ? action.payload.user : state.user,
            token: action.payload ? action.payload.token : null,
            refresh_token: action.payload ? action.payload.refreshToken : null,
         });
      case AuthActionTypes.SIGNUP_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.SIGNUP_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            user: action.payload ? action.payload.user : null,
            token: action.payload ? action.payload.token : null,
            refresh_token: action.payload ? action.payload.refreshToken : null,
         });

      case AuthActionTypes.FORGOTPASSWORD_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.FORGOTPASSWORD_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            forgotPasswordSuccessAPI: action.payload,
         });

      case AuthActionTypes.RESETPASSWORD_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.RESETPASSWORD_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            resetPasswordSuccessAPI: action.payload,
         });

      case AuthActionTypes.VERIFICATION_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.VERIFICATION_FULFILLED:
         return updateObject(state, {
            isLoading: false,
         });

      case AuthActionTypes.RESENDVERIFICATION_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.RESENDVERIFICATION_FULFILLED:
         return updateObject(state, { isLoading: false });

      case AuthActionTypes.USERAPI_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.USERAPI_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            user: action.payload ? action.payload.user : null,
         });

      case AuthActionTypes.PROFILE_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.PROFILE_FULFILLED:
         return updateObject(state, {
            isLoading: false,
         });

      case AuthActionTypes.ADDCARD_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.ADDCARD_FULFILLED:
         return updateObject(state, { isLoading: false });
      case AuthActionTypes.PLANID:
         return updateObject(state, {
            planid: action.payload ? action.payload.planid : null,
         });

      case AuthActionTypes.PLANNAME:
         return updateObject(state, {
            planName: action.payload ? action.payload.planName : null,
         });

      case AuthActionTypes.PLANPRICE:
         return updateObject(state, {
            planPrice: action.payload ? action.payload.planPrice : null,
         });

      case AuthActionTypes.SUBSCRIBE_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.SUBSCRIBE_FULFILLED:
         return updateObject(state, { isLoading: false });

      case AuthActionTypes.GETSUB_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.GETSUB_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            subdata: action.payload,
         });

      case AuthActionTypes.PLANS_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.PLANS_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            plans: action.payload,
         });

      case AuthActionTypes.CANCELSUB_PENDING:
         return updateObject(state, { isLoading: true });
      case AuthActionTypes.CANCELSUB_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            cancelsubdata: action.payload,
         });

      case AuthActionTypes.UPLOAD_PHOTO_PENDING:
         return updateObject(state, {
            isImageUploading: true,
            isLoading: true,
         });
      case AuthActionTypes.UPLOAD_PHOTO_FULFILLED:
         if (action.payload.urls && action.payload.urls.length > 0) {
            let photoPaths = [];
            action.payload.urls.map((data, index) => {
               photoPaths.push(data.photo_path);
            });
            return updateObject(state, {
               isImageUploading: false,
               isLoading: false,
               photo_path: [...photoPaths],
            });
         } else {
            return updateObject(state, {
               isLoading: false,
            });
         }

      case AuthActionTypes.UPLOAD_PHOTO_TO_S3_BUCKET_PENDING:
         return updateObject(state, {
            isImageUploading: true,
            isLoading: true,
         });
      case AuthActionTypes.UPLOAD_PHOTO_TO_S3_BUCKET_FULFILLED:
         return updateObject(state, {
            isImageUploading: false,
            isLoading: false,
         });

      case AuthActionTypes.UPDATE_TOKEN:
         const { user, token, refresh_token } = action.payload;
         return updateObject(state, {
            isLoading: false,
            user: user,
            token: token,
            refresh_token: refresh_token,
         });

      case AuthActionTypes.COUPONCHECK_PENDING:
         return updateObject(state, { isLoading: true });
         
      case AuthActionTypes.COUPONCHECK_FULFILLED:
         return updateObject(state, {
            isLoading: false,
            discountPrice: action.payload ? action.payload.plans : null,
         });

      case AuthActionTypes.CLEARCOUPON:
         return updateObject(state, {
            discountPrice: null,
         });

      case AuthActionTypes.LOGOUT:
         return updateObject(state, {
            token: null,
            refresh_token: null,
            user: null,
            isLoading: false,
            isImageUploading: false,
            photo_path: [],
            plans: null,
            planid: null,
            planName: null,
            planPrice: null,
            subdata: null,
            cancelsubdata: null,
            successCall: null,
            discountPrice: null,
         });

      default:
         return state;
   }
};
